import React, { Component } from 'react';
import { FormattedPlural } from 'react-intl';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';
import { Card, CardHeader } from 'material-ui/Card';

import { List } from 'material-ui/List';
import CourseModuleListItem from './CourseModuleListItem';
import CourseModuleSubscriptionStore from '../../stores/CourseModuleSubscriptionStore';
import ModuleActions from '../../actions/ModuleActionCreator';

import ListIcon from 'material-ui/svg-icons/action/subject';


const style = {
    list: {
        paddingTop: 0,
        paddingBottom: 0,
    },
};

class ModuleSegment extends Component {

    componentDidMount() {
        if (!!this.props.userId) {
            ModuleActions.getCourseUserSubscriptions(this.props.courseId, this.props.userId);
        }
    }

    render() {

        let subtitle = '';
        let content = null;

        let iconProps = {
            color: 'rgba(117, 117, 117 ,0.7)',
        };

        let avatarIcon = (<ListIcon {...iconProps}/>);

        if (this.props.modules.length > 1 || (this.props.modules.length === 1 && !this.props.designatedModuleId)) {

           subtitle = ( <span>{this.props.modules.length} <FormattedPlural
               value={this.props.modules.length}
               one='module'
               other='modules'
           /></span>);

            const moduleList = this.props.modules.map((module) => {
                const subscription = (!!this.state.subscriptions && this.state.subscriptions.find((sub) => (sub.moduleId === module.id)));
                if (!!subscription) {
                    module.enrolmentStatus = subscription.status;
                    module.enrolmentIsMandatory = subscription.isMandatory;
                    module.enrolmentIsAssigned = subscription.isAssigned;
                    module.enrolmentDate = subscription.dateAdded;
                    module.dateCompleted = subscription.dateCompleted;
                    module.enrolmentScore = subscription.score;
                }
                return (
                    <div key={module.id}>
                        <CourseModuleListItem key={module.id}
                            data={module}
                            actions={[]}
                            link={this.props.link.replace('{moduleId}', module.id)}
                        />
                    </div>
                );
            }, this);

            content = (
                <Card className="cent-card" key="moduleSegment">
                    <CardHeader
                        title="Outline"
                        subtitle={subtitle}
                        avatar={avatarIcon}
                    />
                <List style={style.list}  >
                    {moduleList}
                </List>
                </Card>
            );
        }
        return content;
    }
}

ModuleSegment.propTypes = {
    courseId:           PropTypes.number.isRequired,
    modules:            PropTypes.arrayOf(
        PropTypes.shape({
            id:     PropTypes.number.isRequired
        })),
    link:               PropTypes.string.isRequired,
    userId:             PropTypes.number,
    designatedModuleId: PropTypes.number
};

ModuleSegment.getStores = () => ([CourseModuleSubscriptionStore]);
ModuleSegment.calculateState = (prevState, props) => ({
    subscriptions:  (!!props.userId ? CourseModuleSubscriptionStore.get(props.courseId, props.userId) : [])
});
export default Container.create(ModuleSegment, {withProps: true});
